import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { Chevron } from '@jutro/components';
import { withValidation, validationPropTypes } from '@xengage/gw-portals-validation-react';
import UnderwritingIssues from 'gw-components-platform-react/UnderwritingIssues/UnderwritingIssues';
import QuoteTableAccordionCardIterableComponent from 'gw-components-platform-react/QuoteTableAccordionCardIterableComponent/QuoteTableAccordionCardIterableComponent';
import metadata from './EHRenewalPremiumBoxComponent.metadata.json5';
import styles from './EHRenewalPremiumBoxComponent.module.scss';

function selectMetadata(breakpoint) {
    const contentArray = metadata.componentContent.content;
    let metadataToRender = '';

    if (breakpoint === 'phone') {
        metadataToRender = contentArray.filter((item) => item.id !== 'desktopTable');
    } else {
        metadataToRender = contentArray.filter((item) => item.id !== 'phoneTable' && item.id !== 'mobileAccordionHeader');
    }

    const filteredMetdata = {
        ...metadata,
        componentContent: {
            content: metadataToRender
        }
    };

    return filteredMetdata;
}

class PremiumBoxComponent extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        onChangeSubmission: PropTypes.func,
        viewOnlyMode: PropTypes.bool,
        showMonthlyPaymentComponent: PropTypes.bool,
        ...validationPropTypes
    };

    static defaultProps = {
        onChangeSubmission: undefined,
        showMonthlyPaymentComponent: true,
        viewOnlyMode: false,
    }

    state = {
        formData: {},
    };

    componentDidMount() {
        const {
            renewalVM,
            updateWizardData,
            viewOnlyMode
        } = this.props;

        if (_.get(renewalVM, 'lobData.homeowners_EH.paperlessInd.value') === undefined && !viewOnlyMode) {
            _.set(renewalVM, 'lobData.homeowners_EH.paperlessInd.value', false);
            updateWizardData(renewalVM);
        }
    }

    getTotalPremium() {
        const { renewalVM } = this.props;
        const offerings = _.get(renewalVM, 'lobData.homeowners_EH.offerings.value[0]');

        if (offerings.paymentPlans) {
            const payPlans = _.get(renewalVM, 'lobData.homeowners_EH.offerings.value[0].paymentPlans');
            const selectedPlan = _.filter(payPlans, (plan) => plan.isSelected);
            const totalPremium = selectedPlan[0]?.total?.amount;

            if (!totalPremium && totalPremium !== 0) {
                return undefined;
            }

            _.set(renewalVM, 'unverfiedPremium', totalPremium);

            return { currency: 'usd', amount: totalPremium };
        }

        return undefined;
    }

    writeValue = (value, path) => {
        const { formData } = this.state;

        _.set(formData, path, value);
        this.setState({ formData });
    };

    generateOverrides() {
        const {
            renewalVM,
            viewOnlyMode,
            authHeader,
            updateWizardData,
            underwritingIssues,
            showMonthlyPaymentComponent,
            authUserData
        } = this.props;
        const userRolePremiumViewRoles = authUserData?.permissions_Ext.includes('viewpremium_ext');
        const allUWIssuesApproval = underwritingIssues?.every((item) => item?.approvalBlockingPoint === 'NonBlocking');
        const showPremium = (underwritingIssues === undefined || underwritingIssues.length === 0) || userRolePremiumViewRoles || allUWIssuesApproval;

        return {
            '@field': {
                // apply to all fields
                onValueChange: this.writeValue,
                disabled: viewOnlyMode,
                showRequired: true,
                autoComplete: false
            },
            totalPremiumID: {
                value: !_.isNil(this.getTotalPremium())
                    ? this.getTotalPremium() : undefined
            },
            twelveMonthsCheckboxField: {
                disabled: true
            },
            paymentOptionsID: {
                submissionVM: renewalVM,
                authHeader,
                updateWizardData,
                LOB: 'homeowners_EH',
                viewOnly: viewOnlyMode
            },
            premiumDetailsMainGrid: {
                visible: showPremium
            },
            monthlyPaymentScheduleComponent: {
                quoteID: renewalVM.value.jobID,
                authHeader,
                transactionTotalAmount: renewalVM.totalCost?.value,
                startDate: renewalVM.baseData.periodStartDate.value,
                endDate: renewalVM.baseData.periodEndDate.value,
                changeInCost: renewalVM.transactionCost?.value,
                jobTypeCode: renewalVM.baseData.jobType.value.code,
                offerings: _.get(renewalVM, 'lobData.homeowners_EH.offerings.value'),
                visible: showMonthlyPaymentComponent
            }
        };
    }

    renderClauseTable = (breakpoint) => {
        const {
            setComponentValidation, onChangeSubmission, renewalVM, underwritingIssues, authUserData
        } = this.props;

        const { formData } = this.state;
        const dataForComponent = {
            ...formData,
            ..._.pick(this.props, ['columnData', 'tableData', 'modifiers']),
            ...renewalVM,
            totalPremium: this.getTotalPremium(),
        };
        const userRolePremiumViewRoles = authUserData?.permissions_Ext.includes('viewpremium_ext');
        const showPremium = (underwritingIssues === undefined || underwritingIssues.length === 0) || userRolePremiumViewRoles;


        const resolvers = {
            resolveClassNameMap: styles,
            resolveComponentMap: {
                chevron: Chevron,
                quotetableaccordioncarditerablecomponent: QuoteTableAccordionCardIterableComponent,
                underwritingissues: UnderwritingIssues
            },
            resolveCallbackMap: {
                onChangeSubmissionAndSync: this.changeSubmissionAndSync,
                onSyncCoverages: this.syncCoverages,
                onChangeSubmission,
            }
        };
        const generatedMetadata = selectMetadata(breakpoint);

        return (
            <ViewModelForm
                uiProps={generatedMetadata.componentContent}
                model={dataForComponent}
                overrideProps={this.generateOverrides(breakpoint)}
                onValueChange={this.writeValue}
                onValidationChange={setComponentValidation}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                showPremium={showPremium}
            />
        );
    }

    render() {
        return (
            <BreakpointTrackerContext.Consumer>
                {this.renderClauseTable}
            </BreakpointTrackerContext.Consumer>
        );
    }
}

export default withValidation(PremiumBoxComponent);
